export const recalculateProgressForSyllabuses =
  '/syllabus/api/recalculate-progress-for-syllabuses';

export default {
  get_options_for_milestone_learning_items:
    '/syllabus/schema-form/get-options-for-milestone-learning-items',
};
